import React from 'react';

import { CatalogFn, CatalogJson } from '../../catalog/catalog';
import { Item as ItemModel, Layer, Scene } from '../../models';
import If from '../../utils/react-if';

const STYLE_CIRCLE = {
  fill: '#0096fd',
  stroke: '#0096fd',
  cursor: 'ew-resize'
};

const STYLE_CIRCLE2 = {
  fill: 'none',
  stroke: '#0096fd',
  cursor: 'ew-resize'
};

interface ItemProps {
  layer: Layer;
  item: ItemModel;
  scene: Scene;
  catalog: CatalogJson;
}

export default function Item({ layer, item, scene, catalog }: ItemProps) {
  const { x, y, rotation } = item;

  const renderedItem = CatalogFn.getElement(catalog, item.type).render2D(
    item,
    layer,
    scene
  );

  return (
    <g
      data-element-root
      data-prototype={item.prototype}
      data-id={item.id}
      data-selected={item.selected}
      data-layer={layer.id}
      style={item.selected ? { cursor: 'move' } : {}}
      transform={`translate(${x},${y}) rotate(${rotation})`}
    >
      {renderedItem}
      <If condition={item.selected} style={{}}>
        <g
          data-element-root
          data-prototype={item.prototype}
          data-id={item.id}
          data-selected={item.selected}
          data-layer={layer.id}
          data-part="rotation-anchor"
        >
          <circle cx="0" cy="150" r="10" style={STYLE_CIRCLE} />
          <circle cx="0" cy="0" r="150" style={STYLE_CIRCLE2} />
        </g>
      </If>
    </g>
  );
}
